import Vue from 'vue'
import title from './fragments/title'
import { furnishingKey } from '@/util/furnishing'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const realties = (data) => {
  const realties = data?.realties

  if (!realties && realties.length <= 0) return ''

  return realties.map((realty) => {
    return `
      <details>
        ${title(translate(area + 'realties'))}
        <content>
          <h6 class="text-uppercase grey--text mt-2">
            ${translate(area + 'realtyCode')}
          </h6>
          <p class="mb-1 mt-1 v-chip v-chip--no-color theme--light v-size--small">
            ${realty.code}
          </p>

          <h6 class="text-uppercase grey--text mt-2">
            ${translate(area + 'address')}
          </h6>
          <p class="body-2 mb-3">
            ${realty.address}
          </p>

          ${
            realty?.additional_address_data
              ? `
                <h6 class="text-uppercase grey--text mt-2">${translate(area + 'additionalAddressData')}</h6>
                <p class="body-2 mb-3">${realty.additional_address_data}</p>
              `
              : ''
          }

          <div class="row no-gutters">
            <div class="col">
              <h6 class="text-uppercase grey--text">
                ${translate(area + 'totalArea')}
              </h6>
              <p class="body-2 mb-3">
                ${realty.square_meters} m²
              </p>
            </div>
            <div class="col">
              <h6 class="text-uppercase grey--text">
                ${translate(area + 'privateArea')}
              </h6>
              <p class="body-2 mb-3">
                ${realty.private_area_meters} m²
              </p>
            </div>
            <div class="col">
              <h6 class="text-uppercase grey--text">
                ${translate(area + 'furnished')}
              </h6>
              <p class="body-2 mb-3">
                ${
                  furnishingKey(realty)
                    ? translate(furnishingKey(realty))
                    : translate(area + 'no')
                }
              </p>
            </div>
            <div class="col">
              <h6 class="text-uppercase grey--text">
                ${translate(area + 'trousseau')}
              </h6>
              <p class="body-2 mb-3">
                ${
                  realty.trousseau
                    ? translate(area + 'yes')
                    : translate(area + 'no')
                }
              </p>
            </div>
            <div class="col">
              <h6 class="text-uppercase grey--text">
                ${translate(area + 'painting.label')}
              </h6>
              <p class="body-2 mb-3 text-no-wrap">
                ${
                  realty.painting_status
                    ? translate(area + `painting.${realty.painting_status}`)
                    : '---'
                }
              </p>
            </div>
          </div>
        </content>
      </details>
    `
  })
}

export default realties
